module.exports = __webpack_public_path__ + "img/soccer-background-desktop.f51165da.png";